// extracted by mini-css-extract-plugin
export default {"wrapper":"ReagentsPredilution_wrapper__IdD4t","preDilution":"ReagentsPredilution_preDilution__2QnRg"};